import { Link } from "react-router-dom";
import { Typography, theme } from "antd";

/** Logo + nazwa panelu; po zwinięciu panelu bocznego zostaje samo logo. */
export const AdminTitle = ({ collapsed }: { collapsed: boolean }) => {
  const { token } = theme.useToken();
  return (
    <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0, color: token.colorText }}>
      <img
        src="/mercury_hub_logo.webp"
        alt="Mercury Hub"
        width={28}
        height={28}
        style={{ borderRadius: 6, flexShrink: 0 }}
      />
      {!collapsed && (
        <span style={{ display: "flex", alignItems: "baseline", gap: 6, minWidth: 0, whiteSpace: "nowrap" }}>
          <Typography.Text strong style={{ fontSize: 16 }}>
            Mercury Hub
          </Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            admin
          </Typography.Text>
        </span>
      )}
    </Link>
  );
};
